import { BorderBox, Position, Text } from '@trmediaab/zebra';

interface PaymentIntervalProps {
  paymentInterval: number;
}

const PaymentInterval = ({ paymentInterval }: PaymentIntervalProps) => (
  <Position.absolute
    top={['13px', null, null, '-18px']}
    right={['13px', null, null, '-18px']}
  >
    <BorderBox
      borderRadius="circle"
      boxShadow="0 2px 6px 0 rgba(182, 182, 182, 0.6)"
      bg="offersPage.badge.background"
      color="offersPage.badge.foreground"
      width={['65px', null, '72px']}
      height={['65px', null, '72px']}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        fontWeight="extraBold"
        fontSize={{ _: 3, md: 5 }}
        lineHeight="1"
        mt="-2px"
      >
        {paymentInterval}
      </Text>
      <Text fontSize="0" fontWeight="bold" lineHeight="1">
        månad{paymentInterval > 1 ? 'er' : ''}
      </Text>
    </BorderBox>
  </Position.absolute>
);

export default PaymentInterval;
